<script>
import Layout from '@/router/layouts/main';
import Repositories from '@/repositories';
const SuppliersRepository = Repositories.get('suppliers');
const ItemsRepository = Repositories.get('items');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Lists from './components/lists.vue';
import OrderItemsList from './components/order-items-list.vue';

/**
 * Shopping Cart Component
 */
export default {
  page: {
    title: 'ShoppingCart',
  },
  components: {
    Layout,
    Loading,
    Lists,
    OrderItemsList,
  },
  data() {
    return {
      isLoadingPage: false,
      items: [
        {
          text: 'shoppingCart',
          href: '/cart',
        },
        {
          text: '',
          active: true,
        },
      ],
      selectedWorkOrderItems: [],
      selectedItems: [],
      suppliers: [],
      orderItemsList: [],
      lastWheelTime: null,
      currentStep: 1,
      //To be able to force the refresh when we create an order
      refreshTime: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.selectedWorkOrderItems = [];
      this.selectedItems = [];
      this.suppliers = [];
      this.orderItemsList = [];
      this.lastWheelTime = null;
      this.currentStep = 1;

      this.isLoadingPage = true;

      SuppliersRepository.getAll()
        .then((response) => {
          this.suppliers = response.data.data;
          this.isLoadingPage = false;
        })
        .catch(() => {
          this.isLoadingPage = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    async addWorkOrderItem(workOrderItem) {
      this.isLoadingPage = true;
      let orderItem = await this.getOrderItemFromItem(
        workOrderItem.itemIdPublic
      );

      if (orderItem != null) {
        let workOrderItemIndex = orderItem.workOrderItems.findIndex(
          (x) => x.idPublic == workOrderItem.idPublic
        );

        if (workOrderItemIndex < 0) {
          orderItem.workOrderItems = [
            ...orderItem.workOrderItems,
            {
              idPublic: workOrderItem.idPublic,
              requestedQuantity: workOrderItem.requestedQuantity,
              workOrderDeliveryDate: workOrderItem.workOrderDeliveryDate,
              workOrderName: workOrderItem.workOrderName,
            },
          ];

          orderItem.workOrderItemsSum = orderItem.workOrderItems.reduce(
            function(prev, cur) {
              return prev + cur.requestedQuantity;
            },
            0
          );
        }

        this.updateOrderItem(orderItem);

        if (!this.selectedWorkOrderItems.includes(workOrderItem.idPublic)) {
          this.selectedWorkOrderItems = [
            workOrderItem.idPublic,
            ...this.selectedWorkOrderItems,
          ];
        }
      }
      this.isLoadingPage = false;
    },
    removeWorkOrderItem(orderItem, workOrderItemIdPublic) {
      let newOrderItem = {
        ...orderItem,
        workOrderItems: orderItem.workOrderItems.filter(
          (x) => x.idPublic != workOrderItemIdPublic
        ),
      };

      newOrderItem.workOrderItemsSum = newOrderItem.workOrderItems.reduce(
        function(prev, cur) {
          return prev + cur.requestedQuantity;
        },
        0
      );

      if (
        newOrderItem.workOrderItemsSum + newOrderItem.requestedQuantity <=
        0
      ) {
        this.removeOrderItem(newOrderItem);
      } else {
        this.updateOrderItem(newOrderItem);
      }

      this.selectedWorkOrderItems = this.selectedWorkOrderItems.filter(
        (x) => x != workOrderItemIdPublic
      );
    },
    async addItem(item, quantityType) {
      this.isLoadingPage = true;
      let orderItem = await this.getOrderItemFromItem(item.idPublic);

      if (orderItem != null) {
        orderItem = {
          ...orderItem,
          requestedQuantity:
            quantityType == 'critical' ? 0 : item.orderRequestQuantity,
        };

        this.updateOrderItem(orderItem);

        if (!this.selectedItems.includes(item.idPublic)) {
          this.selectedItems = [item.idPublic, ...this.selectedItems];
        }
      }
      this.isLoadingPage = false;
    },
    updateOrderItem(orderItem) {
      let foundIndex = this.orderItemsList.findIndex(
        (x) => x.itemIdPublic == orderItem.itemIdPublic
      );

      let editedVal = orderItem.editedQuantity;

      if (
        orderItem.requestedQuantity + orderItem.workOrderItemsSum >
        editedVal
      ) {
        editedVal = 0;
      }

      this.orderItemsList = [
        ...this.orderItemsList.slice(0, foundIndex),
        { ...orderItem, editedQuantity: editedVal },
        ...this.orderItemsList.slice(foundIndex + 1),
      ];
    },
    async getOrderItemFromItem(itemIdPublic) {
      let itemIndex = this.orderItemsList.findIndex(
        (orderItem) => orderItem.itemIdPublic == itemIdPublic
      );

      if (itemIndex < 0) {
        try {
          let {
            data: item,
          } = await ItemsRepository.customREST.getWithItemSuppliers(
            itemIdPublic
          );

          let itemSuppliersList = item.itemSuppliers.map((x) => {
            let supplierIndex = this.suppliers.findIndex(
              (y) => y.idPublic == x.supplierIdPublic
            );
            if (supplierIndex >= 0) {
              x.supplierName = this.suppliers[supplierIndex].name;
            }
            return x;
          });

          let newItem = {
            itemIdPublic: itemIdPublic,
            itemName: item.name,
            selectedSupplierIdPublic: item.supplierIdPublic,
            quantityType: item.quantityType,
            unitType: item.unitType,
            requestedQuantity: 0,
            workOrderItemsSum: 0,
            editedQuantity: 0,
            workOrderItems: [],
            suppliersList: itemSuppliersList,
          };

          this.orderItemsList = [...this.orderItemsList, newItem];
          return newItem;
        } catch (error) {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          return null;
        }
      } else {
        return this.orderItemsList[itemIndex];
      }
    },
    removeOrderItem(orderItem) {
      let itemIndex = this.orderItemsList.findIndex(
        (x) => x.itemIdPublic == orderItem.itemIdPublic
      );

      if (itemIndex >= 0) {
        //Remove selected elements from selected lists
        this.selectedItems = this.selectedItems.filter(
          (x) => x != orderItem.itemIdPublic
        );
        this.orderItemsList[itemIndex].workOrderItems.forEach((element) => {
          this.selectedWorkOrderItems = this.selectedWorkOrderItems.filter(
            (x) => x != element.idPublic
          );
        });

        //remove from order items
        this.orderItemsList.splice(itemIndex, 1);
      }
    },
    refreshData() {
      this.loadData();

      //To force the re-render of lists component
      this.refreshTime = Date.now();
    },
  },
};
</script>

<template>
  <Layout :title="$t('shoppingCart.shoppingCart')">
    <loading
      :active.sync="isLoadingPage"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <Lists
      :suppliers="suppliers"
      :selectedItems="selectedItems"
      :selectedWorkOrderItems="selectedWorkOrderItems"
      @add-work-order-item="addWorkOrderItem"
      @add-item="addItem"
      :key="refreshTime"
    />
    <OrderItemsList
      :orderItemsList="orderItemsList"
      @update-order-item="updateOrderItem"
      @remove-order-item="removeOrderItem"
      @remove-work-order-item="removeWorkOrderItem"
      @refresh-data="refreshData"
    />
  </Layout>
</template>

<style scoped></style>
